jQuery(document).ready(function ($) {
    function getRedirectUrl(button) {
        var redirectUrl = button.closest(".templazee-post").find(".templazee-post-title a").attr("href");
        if (!redirectUrl) {
            redirectUrl = window.location.href;
        }
        return redirectUrl;
    }

    function shareOnSocialMedia(shareUrl) {
        window.open(shareUrl, "_blank", "width=800,height=500");
    }

    $(".templazee-pro-facebook-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(redirectUrl)}`;
        shareOnSocialMedia(facebookShareUrl);
    });

    $(".templazee-pro-twitter-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var twitterShareUrl = `https://twitter.com/intent/tweet?text=YOUR_TEXT&url=${encodeURIComponent(redirectUrl)}`;
        shareOnSocialMedia(twitterShareUrl);
    });

    $(".templazee-pro-gmail-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var gmailShareUrl = ` mailto:?subject=Shared%20through%20%20social%20share%20block&body=${encodeURIComponent(
            redirectUrl
        )}`;
        shareOnSocialMedia(gmailShareUrl);
    });

    $(".templazee-pro-whatsApp-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var redditShareUrl = `https://api.whatsapp.com/send?text=Check%20out%20this%20awesome%20website:%20${encodeURIComponent(
            redirectUrl
        )}`;
        shareOnSocialMedia(redditShareUrl);
    });

    $(".templazee-pro-linkedIn-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var linkedInShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
            redirectUrl
        )}`;
        shareOnSocialMedia(linkedInShareUrl);
    });

    $(".templazee-pro-reddit-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var redditShareUrl = `https://www.reddit.com/submit?url=${encodeURIComponent(
            redirectUrl
        )}`;
        shareOnSocialMedia(redditShareUrl);
    });

    $(".templazee-pro-tumblr-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var tumblrShareUrl = `https://www.tumblr.com/widgets/share/tool?canonicalUrl=${encodeURIComponent(
            redirectUrl
        )}`;
        shareOnSocialMedia(tumblrShareUrl);
    });

    $(".templazee-pro-diigo-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var diigoShareUrl = `https://www.diigo.com/post?url=${encodeURIComponent(
            redirectUrl
        )}`;
        shareOnSocialMedia(diigoShareUrl);
    });

    $(".templazee-pro-pinterest-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var pinterestShareUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(
            redirectUrl
        )}L&description=Shared%20through%20%20social%20share%20block`;
        shareOnSocialMedia(pinterestShareUrl);
    });

    $(".templazee-pro-viber-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var viberShareUrl = `viber://forward?text=Shared%20through%20%20social%20share%20block%20${encodeURIComponent(
            redirectUrl
        )}`;
        shareOnSocialMedia(viberShareUrl);
    });

    $(".templazee-pro-snapchat-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var snapchatShareUrl = `https://www.snapchat.com/send?text=Shared%20through%20%20social%20share%20block%20${encodeURIComponent(
            redirectUrl
        )}`;
        shareOnSocialMedia(snapchatShareUrl);
    });

    $(".templazee-pro-telegram-share").on("click", function (e) {
        e.preventDefault();

        var redirectUrl = getRedirectUrl($(this));
        if (!redirectUrl) return;

        var telegramShareUrl = `https://t.me/share/url?ur&${encodeURIComponent(
            redirectUrl
        )}text=Shared%20through%20%20social%20share%20block%20`;
        shareOnSocialMedia(telegramShareUrl);
    });

    $(".templazee-pro-social-share-button").on("click", function (e) {
        e.preventDefault();
        $(this).parent().toggleClass("button-clicked");
    })

    $('.templazee-pro-social-share-button').each(function () {
        var $button = $(this);
        var $wrapper = $button.siblings('.templazee-pro-social-share-wrapper.hover-enabled');
        
        $button.on('mouseenter', function () {
            $wrapper.addClass('hovered');
        });
    
        $wrapper.on('mouseenter', function () {
            $wrapper.addClass('hovered');
        });
    
        $wrapper.on('mouseleave', function () {
            $wrapper.removeClass('hovered');
        });

        $button.on('mouseleave', function () {
            if (!$wrapper.is(':hover')) {
                $wrapper.removeClass('hovered');
            }
        });
    });
    
});